module.exports = __webpack_public_path__ + "static/Piercer-870f8b6c508db87f32a8248722166d5c.jpg";